import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { FormServiceLayout, FormServiceFieldHandlingCodeOnPageLoad, FormServiceFieldHandlingCodeOptIn, FormServiceFieldHandlingCodeOptOut, FormServiceFieldHandlingDynamicField, FormServiceFieldHandlingGoogleConsentMode, FormServiceFieldHandlingTagManagerEventName } from "../..";
import { useFormService, useI18n } from "../../../../../contexts";
import { FormHeadline } from "../../..";
import { Notices } from "../../../../common";
import { Button, Form, InputNumber, Popover } from "antd";
import { getManagerDependingVariables } from "@devowl-wp/cookie-consent-web-client";
import { NumberOutlined } from "@ant-design/icons";
const FormServiceFieldHandlingCompose = ()=>{
    const { __, _i } = useI18n();
    const { template, setCookiesViaManager, contentBlockerTemplates, defaultTemplateValues, isGcm } = useFormService();
    const templateDefaultName = (defaultTemplateValues == null ? void 0 : defaultTemplateValues.name) || "";
    const { managerLabel } = getManagerDependingVariables(setCookiesViaManager, {
        isGcm,
        presetId: template == null ? void 0 : template.identifier
    });
    const scanResult = template == null ? void 0 : template.consumerData.scan;
    const technicalHandlingIntegration = template == null ? void 0 : template.consumerData.technicalHandlingIntegration;
    const notices = [
        {
            message: template == null ? void 0 : template.technicalHandlingNotice,
            severity: "info"
        },
        {
            message: technicalHandlingIntegration ? _i(__("The {{strong}}%1$s{{/strong}} plugin is connected to this service. This means that the scripts mentioned below may not be run exactly as they are or may be changed. So, it's best not to make any further changes or delete the script. Instead, if you want to make changes related to {{strong}}%2$s{{/strong}}, please do it directly in the {{strong}}%1$s{{/strong}}.", technicalHandlingIntegration.name, template.name), {
                strong: /*#__PURE__*/ _jsx("strong", {})
            }) : undefined,
            severity: "info"
        },
        !!scanResult && template.codeOptIn && [
            "wordpress-comments"
        ].indexOf(template.identifier) === -1 && {
            message: contentBlockerTemplates.length > 0 ? __('You are currently embedding "%1$s" outside of Real Cookie Banner. You can have it blocked via a content blocker before consenting. Alternatively, you can use the following opt-in script to load %1$s directly into Real Cookie Banner.<br /><br />If you want to embed "%1$s" via Real Cookie Banner, you have to deactivate the content blocker at the end of the form and remove "%1$s" outside Real Cookie Banner.<br /><br />If you prefer to keep the current integration, you only have to delete the opt-in script in this form.', templateDefaultName) : __("If you have already used %s before creating this service, please deactivate the script/plugin with which the service was loaded so far. The opt-in script will now take care of the correct integration.", templateDefaultName),
            severity: "warning"
        }
    ].filter(Boolean).filter((param)=>{
        let { message } = param;
        return message;
    });
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(FormHeadline, {
                offset: FormServiceLayout.labelCol.span,
                headlineExtra: /*#__PURE__*/ _jsx(Popover, {
                    title: __("Priority of script execution"),
                    placement: "bottomRight",
                    overlayStyle: {
                        maxWidth: 500
                    },
                    forceRender: true,
                    content: /*#__PURE__*/ _jsx(Form.Item, {
                        name: "executePriority",
                        rules: [
                            {
                                type: "number",
                                min: 0,
                                max: 99,
                                required: true,
                                message: __("Please provide a valid priority!")
                            }
                        ],
                        style: {
                            marginBottom: 0
                        },
                        extra: /*#__PURE__*/ _jsx("p", {
                            className: "description",
                            style: {
                                margin: "10px 0 0 0"
                            },
                            children: _i(__("Scripts executed on opt-in or on opt-out can have the property {{code}}unique-write-name{{/code}}. If multiple scripts have the same name, only one will be executed to avoid multiple executions. If scripts with the same name are executed in different services, the one with the lowest priority is executed (defines the execution order). Changing the priority is relevant, for example, if you create two services for tracking with and without cookies (on different legal bases) for the same analysis tool."), {
                                code: /*#__PURE__*/ _jsx("code", {})
                            })
                        }),
                        children: /*#__PURE__*/ _jsx(InputNumber, {
                            min: 0,
                            max: 99,
                            addonBefore: __("Priority")
                        })
                    }),
                    children: /*#__PURE__*/ _jsx(Button, {
                        type: "link",
                        icon: /*#__PURE__*/ _jsx(NumberOutlined, {}),
                        children: __("Priority")
                    })
                }),
                description: !managerLabel ? __("Define HTML and JavaScript code that is executed when a visitor decides to accept or reject this service or when a page is loaded. It is important to define the executed code correctly, as this ensures that scripts are executed and cookies are set only after the user's consent.") : __("Define the %1$s event that should be thrown in the data layer when a visitor decides to accept or reject this service. The event can be used as a trigger in %1$s. For users who do not allow to use %1$s a fallback can be defined. You can define HTML and JavaScript code that is executed when a visitor decides to accept or reject this service, or when a page is loaded. It is important to define the event names and executed code correctly, as this will ensure that scripts are executed and cookies are only set with the user's consent.", managerLabel),
                children: __("Technical handling")
            }),
            /*#__PURE__*/ _jsx(FormServiceFieldHandlingTagManagerEventName, {}),
            /*#__PURE__*/ _jsx(FormServiceFieldHandlingGoogleConsentMode, {}),
            /*#__PURE__*/ _jsx(FormServiceFieldHandlingDynamicField, {}),
            notices.length > 0 && /*#__PURE__*/ _jsx(Form.Item, {
                wrapperCol: {
                    offset: FormServiceLayout.labelCol.span,
                    span: FormServiceLayout.wrapperCol.span
                },
                style: {
                    marginBottom: 10
                },
                children: /*#__PURE__*/ _jsx(Notices, {
                    notices: notices
                })
            }),
            /*#__PURE__*/ _jsx(FormServiceFieldHandlingCodeOptIn, {}),
            /*#__PURE__*/ _jsx(FormServiceFieldHandlingCodeOptOut, {}),
            /*#__PURE__*/ _jsx(FormServiceFieldHandlingCodeOnPageLoad, {})
        ]
    });
};
export { FormServiceFieldHandlingCompose };
